/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientCreditBalanceTransaction
 */
export interface PatientCreditBalanceTransaction {
    /**
     * 
     * @type {string}
     * @memberof PatientCreditBalanceTransaction
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCreditBalanceTransaction
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCreditBalanceTransaction
     */
    created: number;
}

/**
 * Check if a given object implements the PatientCreditBalanceTransaction interface.
 */
export function instanceOfPatientCreditBalanceTransaction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function PatientCreditBalanceTransactionFromJSON(json: any): PatientCreditBalanceTransaction {
    return PatientCreditBalanceTransactionFromJSONTyped(json, false);
}

export function PatientCreditBalanceTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientCreditBalanceTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'amount': json['amount'],
        'created': json['created'],
    };
}

export function PatientCreditBalanceTransactionToJSON(value?: PatientCreditBalanceTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'amount': value.amount,
        'created': value.created,
    };
}

